import React from "react";
import ChartWrapper from "../graph/ChartWrapper";
import {
  CardData,
  CategoryDef,
} from "api/interfaces/dashboardInterface.interface";
import { getCloudStorage } from "api/widgetAPI";
import useStatsData from "hook/useStatsData";

export default function CloudStorage(props: CardData) {
  const { statsData, data, legend, interval, setInterval } = useStatsData({
    queryFn: getCloudStorage,
    queryName: "cloudStorage",
    items: props.items as CategoryDef[],
    unit: "bytes",
  });
  return (
    <ChartWrapper
      rows={data}
      items={props.items as CategoryDef[]}
      onChangeInterval={setInterval}
      interval={interval}
      unit="bytes"
      legend={legend}
      isLoading={statsData.isLoading}
    />
  );
}
